export const PROMOTION_TYPE_SPECIAL = 'special';
export const PROMOTION_TYPE_FLEX = 'flex';
export const PROMOTION_TYPE_SAFETY = 'safety';